import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "Google Ads",
    "google",
    "Google Ads - Amazon Landing Page",
    "Google Ads (VT)",
    "Google Ads Non Branded",
    "Google Ads",
    "Google Brand",
    "Google Organic",
    "Google Shopping Organic",
    "Google Shopping",
  ],
  iconColor: "#71D5D5", // pluto
  getIcon(options) {
    return createIcon(
      `<path
        d="M12.7185 7.19182C12.0312 6.79695 11.1522 7.03127 10.7553 7.71522L7.19278 13.8548C6.79593 14.5387 7.03143 15.4133 7.71882 15.8082C8.4062 16.203 9.28516 15.9687 9.68204 15.2848L13.2446 9.14518C13.6415 8.46124 13.4059 7.58669 12.7185 7.19182Z"
        fill="#FFC107"
      />
      <path
        d="M12.7186 7.19176C12.3975 7.00731 12.0347 6.96022 11.6987 7.03205C11.8413 7.06261 11.9818 7.11524 12.115 7.19176C12.8024 7.58663 13.0379 8.46118 12.641 9.14512L9.0785 15.2847C8.86701 15.6492 8.51861 15.8859 8.13525 15.9678C8.72889 16.095 9.36217 15.8361 9.68211 15.2847L13.2446 9.14512C13.6415 8.46118 13.406 7.58663 12.7186 7.19176V7.19176Z"
        fill="#FFB300"
      />
      <ellipse cx="8.43566" cy="14.572" rx="1.43566" ry="1.42846" fill="#01C381" />
      <path
        d="M8.13519 15.9678C8.13511 15.968 8.13507 15.9682 8.13501 15.9683C8.232 15.9889 8.33251 15.9999 8.43567 15.9999C9.22856 15.9999 9.87134 15.3604 9.87134 14.5715C9.87134 14.3962 9.83946 14.2284 9.78142 14.0732L9.07845 15.2847C8.86694 15.6492 8.51855 15.8859 8.13519 15.9678Z"
        fill="#01C381"
      />
      <path
        d="M16.8071 13.8548L13.2445 7.71522C12.8477 7.03127 11.9687 6.79695 11.2813 7.19182C10.5939 7.58669 10.3584 8.46124 10.7553 9.14518L14.3178 15.2848C14.7147 15.9687 15.5937 16.203 16.2811 15.8082C16.9684 15.4133 17.204 14.5387 16.8071 13.8548V13.8548Z"
        fill="#2196F3"
      />
      <path
        d="M16.8071 13.8545L13.2446 7.71496C12.9246 7.16358 12.2914 6.90467 11.6978 7.03185C12.0811 7.11378 12.4295 7.3505 12.641 7.71496L16.2036 13.8545C16.6004 14.5385 16.3649 15.413 15.6775 15.8079C15.5443 15.8844 15.4039 15.937 15.2612 15.9676C15.5972 16.0394 15.9601 15.9923 16.2812 15.8079C16.9685 15.413 17.204 14.5385 16.8071 13.8545Z"
        fill="#1E88E5"
      />`,
      "#F1FBFB", // pluto-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
